import React from 'react';
import useTranslate from '../../Hooks/useTranslate';
import { Tooltip, IconButton as MUIIconButton } from '@mui/material';

const IconButton = function IconButton({
  id = '',
  title = '',
  onClick = () => {},
  size = 'medium',
  disabled = false,
  children,
  tooltipProps = {},
  iconProps = {},
}) {
  const translate = useTranslate();
  const button = (
    <MUIIconButton
      id={id}
      onClick={onClick}
      size={size}
      disabled={disabled}
      {...iconProps}
    >
      {children}
    </MUIIconButton>
  );
  return (
    <Tooltip title={translate(title)} placement="bottom" {...tooltipProps}>
      {/* A disabled button fires no events, so the tooltip listens on this wrapper. */}
      {disabled ? (
        <span style={{ display: 'inline-flex' }}>{button}</span>
      ) : (
        button
      )}
    </Tooltip>
  );
};

export default IconButton;
